export * from './requests/index';
export * from './web';
export * from './data';
export const yoloRegistrationPath = '/yolo-regisztracio';
export const accountIdParam = '_a';
